let loadingPromise = null
/**
 * Динамически загружает скрипт reCAPTCHA v3
 */
function loadRecaptchaScript () {
  // Если скрипт уже загружен – сразу разрешаем
  if (typeof window.grecaptcha !== 'undefined') {
    return Promise.resolve()
  }

  // Если уже идёт загрузка – возвращаем тот же промис
  if (loadingPromise) {
    return loadingPromise
  }

  // Проверяем, нет ли уже тега <script> на странице
  const existingScript = document.querySelector('script[src*="recaptcha/api.js"]')
  if (existingScript) {
    // Ждём его загрузки
    loadingPromise = new Promise((resolve, reject) => {
      existingScript.addEventListener('load', resolve)
      existingScript.addEventListener('error', reject)
      // Таймаут на случай, если скрипт висит
      setTimeout(() => reject(new Error('Таймаут загрузки reCAPTCHA')), 10000)
    })
    return loadingPromise
  }

  // Создаём новый скрипт
  const script = document.createElement('script')
  script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`
  script.async = true
  script.defer = true

  loadingPromise = new Promise((resolve, reject) => {
    script.onload = resolve
    script.onerror = reject
    // Таймаут на загрузку
    setTimeout(() => reject(new Error('Таймаут загрузки reCAPTCHA')), 10000)
  })

  document.head.appendChild(script)
  return loadingPromise
}

/**
 * Получить токен reCAPTCHA v3
 * @returns {Promise<string>}
 */
function getRecaptchaToken () {
  return new Promise((resolve, reject) => {
    if (typeof window.grecaptcha === 'undefined') {
      reject(new Error('reCAPTCHA не доступен'))
      return
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action: 'login' })
        .then(resolve)
        .catch(reject)
    })
  })
}

export {
  loadRecaptchaScript,
  getRecaptchaToken
}
